import LegendSettings from './LegendSettings';
export default LegendSettings;